import { MapPin, Navigation } from "lucide-react";
import { Reveal } from "./Reveal";
import { LOCATION } from "../data/content";

export const Location = () => {
  return (
    <section
      id="location"
      data-testid="location-section-container"
      className="py-20 md:py-28 px-4 sm:px-8 lg:px-16 bg-[#F4EFEA]"
    >
      <div className="max-w-7xl mx-auto">
        <Reveal>
          <div className="relative mb-14 md:mb-20 rounded-3xl overflow-hidden shadow-2xl border border-[#D5C8B8]">
            <img
              src="/location-banner.jpg"
              alt="Aaroh Farms location connectivity — between Indore and Bhopal"
              className="w-full h-[220px] sm:h-[300px] lg:h-[380px] object-cover"
            />
          </div>
        </Reveal>
      </div>

      <div className="max-w-7xl mx-auto grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
        <div>
          <Reveal>
            <p className="text-xs sm:text-sm uppercase tracking-[0.2em] font-semibold text-[#C15B3D] mb-4">
              Location Advantages
            </p>
            <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl leading-tight tracking-tight text-[#1F291E]">
              {LOCATION.title}
            </h2>
            <div className="mt-6 flex items-start gap-3 text-[#5C6B5A]">
              <MapPin className="h-5 w-5 text-[#2C5F2D] mt-1 shrink-0" />
              <p className="text-lg leading-relaxed">{LOCATION.address}</p>
            </div>
          </Reveal>

          <div className="mt-10 space-y-4">
            {LOCATION.distances.map((d, i) => (
              <Reveal key={d.label} delay={i * 0.08}>
                <div
                  data-testid={`location-distance-item-${i}`}
                  className="flex items-center justify-between gap-4 rounded-xl bg-white/70 border border-[#D5C8B8] px-6 py-4 transition-all duration-300 hover:border-[#2C5F2D]/40 hover:shadow-md"
                >
                  <div className="flex items-center gap-3">
                    <Navigation className="h-4 w-4 text-[#C15B3D]" />
                    <span className="font-medium text-[#1F291E]">
                      {d.label}
                    </span>
                  </div>
                  <span className="font-serif text-[#2C5F2D] text-lg whitespace-nowrap">
                    {d.value}
                  </span>
                </div>
              </Reveal>
            ))}
          </div>
        </div>

        <Reveal delay={0.15}>
          <div className="rounded-2xl overflow-hidden shadow-2xl border border-[#D5C8B8] h-[460px]">
            <iframe
              title="Aaroh Farms location — Sonkatch"
              data-testid="location-map-embed"
              src={LOCATION.mapEmbed}
              className="w-full h-full border-0"
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            />
          </div>
        </Reveal>
      </div>
    </section>
  );
};
